import axios from "../axios";

/**
 * 保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/zyjn/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

export const saveAndDownload = (data, name) => {
  return axios({
    url: "/zyjn/saveAndDownload",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


/**
 * 获取会员个人的记录
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getListByDeptId = (data) => {
  return axios({
    url: "/zyjn/getListByDeptId",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}


export const handleExport = (data, name) => {
  return axios({
    url: "/zyjn/handleExport",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


export const getAppraisalById = (data) => {
  return axios({
    url: "/zyjn/getAppraisalById",
    method: 'post',
    data
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/zyjn/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}
let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/**
 * 同意职业技能鉴定
 */
export const approveZyjnjd = (data) => {
  return axios({
    url: "/zyjn/approveZyjnjd",
    method: 'post',
    data
  })
}
/**
 * 不同意职业技能鉴定
 */
export const rejectZyjnjd = (data) => {
  return axios({
    url: "/zyjn/rejectZyjnjd",
    method: 'post',
    data
  })
}

export const getZyjnpsList = (data) => {
  return axios({
    url: '/zyjn/getZyjnpsList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const getZyjnRecordVInfoById = (data) => {
  return axios({
    url: "/zyjn/getZyjnRecordVInfoById",
    method: 'post',
    data
  })
}

export const saveZyjnPsResult = (data) => {
  return axios({
    url: "/zyjn/saveZyjnPsResult",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}


export const downloadWord = (data) => {
  return axios({
    url: '/zyjn/downloadWord',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

export const handlehzExport = (data, name) => {
  return axios({
    url: "/zyjn/handlehzExport",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

export const exportTjb = (name, data) => {
  return axios({
    url: "/zyjn/exportTjb",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


// 下载导入模板
export function downloadTemplate(fileName) {
  return request({
    url: '/zyjn/downloadTemplate',
    method: 'get',
    responseType: 'blob'
  }).then(res => {
    if (res) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(res, fileName);
      } else {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(res)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      }
    }
  })
}





// WEBPACK FOOTER //
// ./src/http/moudules/zyjn.js